<template>
  <section class="trackActivities">
    <header class="dateHeader" v-if="!changeDateActive">
      <button class="subtleButton dateBrowse" @click="changeDate('prev')"><span class="icontext">Previous</span><span aria-hidden="true">&#60;&#60;</span></button>
      <span @click="changeDateStart">{{ activeDate }}</span>
      <button class="subtleButton dateBrowse" @click="changeDate('next')"><span class="icontext">Next</span><span aria-hidden="true">&#62;&#62;</span></button>
    </header>
    <div v-if="changeDateActive">
      <input ref="changeDateInput" type="date" @blur="changeDate('input')" :value="activeDate" name="activeDate" />
      <br />
      <input type="button" value="save" />
    </div>
    <ul class="trackingGrid">
      <ActivityToggle v-for="activity in activities"
        v-bind:key="activity.id"
        v-bind:activity="activity"
      ></ActivityToggle>
    </ul>
    <div v-if="activitiesEmpty && load1">
      No active activities found. <router-link to="/activities"><a>Manage your activities</a></router-link>
    </div>
    <CalendarWrapper />
    <AddActivity />

  </section>
</template>

<script>
import Vue from 'vue'
import ActivityToggle from '@/components/activities/ActivityToggle'
import AddActivity from '@/components/activities/AddActivity'
import CalendarWrapper from '@/components/calendar/CalendarWrapper'
import {store} from '@/store'
import Dates from '@/mixins/Dates.js'
import DataMain from '@/data/dataMain'

Vue.use(Dates)

export default {
  name: 'TrackActivity',
  components: {
    'ActivityToggle': ActivityToggle,
    'AddActivity': AddActivity,
    'CalendarWrapper': CalendarWrapper
  },
  data () {
    return {
      changeDateActive: false,
      load1: false
    }
  },
  computed: {
    activities () {
      return store.state.activities.active
    },
    activeDate () {
      return store.state.activeDate
    },
    activitiesEmpty () {
      if (this.activities &&
        (typeof this.activities === 'undefined' ||
          (typeof this.activities === 'object' && Object.keys(this.activities).length === 0)
        )
      ) {
        return true
      }
      return false
    }
  },
  mounted () {
    let $this = this
    setTimeout(function () {
      $this.load1 = true
    }, 1000)
  },
  methods: {
    changeDateStart () {
      let $this = this
      this.changeDateToggle()
      Vue.nextTick(function () {
        $this.$refs.changeDateInput.focus()
      })
    },
    changeDateToggle () {
      this.changeDateActive = !this.changeDateActive
    },
    changeDate (action) {
      let d = this.activeDate
      let dt = new Date(d)
      if (action === 'input') {
        this.changeDateToggle()
        d = this.$refs.changeDateInput.value
      } else {
        if (action === 'prev') {
          dt.setDate(dt.getDate() - 1)
        } else if (action === 'next') {
          dt.setDate(dt.getDate() + 1)
        }
        var dn = new Date()
        var n = dn.getTimezoneOffset()
        var offset = n * 60 * 1000
        dt.setTime(dt.getTime() + offset)
        let o = {date: dt}
        d = this.$dateFunctions.formatDate(o)
      }
      DataMain.getMonth(d)
      store.commit('setDate', {
        value: d
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../scss/variables/variables';
  .trackingGrid {
    list-style-type: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/activities/TrackActivity.vue